import React from "react";
import { PaziaModal, PaziaModalSize } from "../Modals";
import { PaziaButton } from "../../atoms";

interface ConfirmationModalProps {
  onCloseRequest: () => void;
  isOpen: boolean;
  title: string;
  description: string;
  onConfirm: () => void;
  onCancel: () => void;
  size?: PaziaModalSize;
}

export const ConfirmationModal = ({
  onCloseRequest,
  isOpen,
  title,
  description,
  onCancel,
  onConfirm,
  size,
}: ConfirmationModalProps) => {
  return (
    <PaziaModal
      id="confirmation-modal"
      size={size}
      onCloseRequest={onCloseRequest}
      isOpen={isOpen}
    >
      <div className="flex flex-col gap-4 px-5 pt-4 pb-6">
        <div className="text-xl">
          <span className="font-medium text-slate-800 dark:text-slate-100 mb-2">
            {title}
          </span>
        </div>
        <div className="text-base">
          <span className="text-slate-800 dark:text-slate-100 mb-2">
            {description}
          </span>
        </div>
        <div className="flex flex-row justify-end gap-2">
          <PaziaButton title="Anuluj" type="tertiary" onClick={onCancel} />
          <PaziaButton title="Potwierdź" type="success" onClick={onConfirm} />
        </div>
      </div>
    </PaziaModal>
  );
};
